import { getDevtools } from '../..'
import type { AdsPanel } from '../../types'

export function addAdsPanel({ getAdService, context }: Pick<AdsPanel, 'getAdService' | 'context'>) {
    const devtools = getDevtools()
    if (!devtools) {
        return
    }
    devtools.addPanel(
        import('./ads-model').then(({ getAdSlotsModel }) => {
            const model = getAdSlotsModel(devtools)
            return {
                kind: 'ads',
                id: 'ads',
                title: 'Ads',
                getAdService,
                context,
                slots: () => model.snapshot(getAdService()),
            }
        }),
    )
}
